import axios from './api';

export default function terms() {
    return new Promise((resolve, reject) => {
        axios.get("home/getTerm", {})
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
